import React, { useRef } from 'react';
import randomNumber from '@sls-react/utils/randomNumber';
import IMG1 from '@sls-react/static/error-page/1.webm';
import IMG2 from '@sls-react/static/error-page/2.webm';
import IMG3 from '@sls-react/static/error-page/3.webm';
import IMG4 from '@sls-react/static/error-page/4.webm';
import IMG5 from '@sls-react/static/error-page/5.webm';
import IMG6 from '@sls-react/static/error-page/6.webm';
import IMG7 from '@sls-react/static/error-page/7.webm';
import IMG8 from '@sls-react/static/error-page/8.webm';
import IMG9 from '@sls-react/static/error-page/9.webm';
import IMG10 from '@sls-react/static/error-page/10.webm';
import IMG11 from '@sls-react/static/error-page/11.webm';
import IMG12 from '@sls-react/static/error-page/12.webm';
import IMG13 from '@sls-react/static/error-page/13.webm';
import IMG14 from '@sls-react/static/error-page/14.webm';
import IMG15 from '@sls-react/static/error-page/15.webm';
import IMG16 from '@sls-react/static/error-page/16.webm';

export const ERROR_IMAGES = [
  IMG1,
  IMG2,
  IMG3,
  IMG4,
  IMG5,
  IMG6,
  IMG7,
  IMG8,
  IMG9,
  IMG10,
  IMG11,
  IMG12,
  IMG13,
  IMG14,
  IMG15,
  IMG16,
];

export function newRandomImage(): number {
  return randomNumber(1, ERROR_IMAGES.length - 1);
}

interface Props {
  initialImage?: number;
}

const ErrorPageImage: React.FC<Props> = ({ initialImage }) => {
  const image = useRef(initialImage || newRandomImage());
  return (
    <video
      autoPlay
      muted
      loop
      className="mx-auto mt-8"
      src={ERROR_IMAGES[image.current]}
    />
  );
};

export default ErrorPageImage;
